import { Notifications } from '@/common/notification';
import { Toaster } from '@/components/ui/sonner';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { ModalProvider } from './providers/modal-provider';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter>
    <ModalProvider>
      <App />
      <Notifications />
      <Toaster position="top-right" />
    </ModalProvider>
  </BrowserRouter>,
);
postMessage({ payload: 'removeLoading' }, '*');
